import React, { useEffect } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { makeStyles, useTheme } from "@mui/styles";
import axios from "../utils/axiosConfig";
import { useSelector, useDispatch } from "react-redux";
import Link from "@mui/material/Link";
// import Button from '@mui/material/Button';

import AppBar from "../components/AppBar";
import Drawer from "../components/Drawer";
import DashboardGrid from "../components/DashboardGrid";
import FeedbackDashboardGrid from "../components/FeedbackDashboardGrid";
import CompletedDashboardGrid from "../components/CompletedDashboardGrid";
import ExpiredDashboardGrid from "../components/ExpiredDashboardGrid";
import DisabledDashboardGrid from "../components/DisabledDashboardGrid";
import AdminDashboardGrid from "../components/AdminDashboardGrid";
import SearchUserDetails from "./SearchUserDetails";
import CandidateSearch from "./CandidateSearch";
import ProctoringFacts from "./ProctoringFacts";
// import ReactModal from 'react-modal';
import Test from "./Test";
import Dialog from "@mui/material/Dialog";
import Transition from "../components/Test/Transition";

import Support from "./Support";
import SiteRequirement from "./SiteRequirement";
import Practice from "./Practice";
import GenerateList from "./GenerateList";
import { selectRole, selectFullName } from "../reducer/authSlice";
import SupportBot from "./SupportBot";
import {
  setButtonArray,
  getButtonArray,
  addUserHome,
  getLoading,
  setGroupDetails,
  getGroupDetails,
  setLoading,
  setOrgId,
  getOrgId,
  getTypeButton,
  setTypeButton,
  setUserHomeDetails,
  getUserHomeDetails,
  setOrgData,
} from "../reducer/dashboardSlice";
import useAutoLogout from "../utils/autoLogout";

// import useUnload from '../components/UseUnload';
// import { Grid } from '@mui/material';

const useStyles = makeStyles((_theme) => ({
  root: {
    display: "flex",
  },
  overlay: {
    overflow: "inherit",
    position: "initial",
    padding: "0px",
    inset: "40px",
    border: "none",
    background: "#fff",
    borderRadius: "12px",
    outline: "none",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
  },
}));


const Dashboard = (props) => {
  const classes = useStyles();
  const _theme = useTheme();
  const dispatch = useDispatch();
  const [typeValue, setType] = React.useState([]);
  // const [buttonArray, setButtonArray] = React.useState([]);
  const [pending, setPending] = React.useState([]);
  const [started, setStarted] = React.useState([]);
  const [buttonName, setButtonClicked] = React.useState("");
  // const [typeButton, setTypeButton] = React.useState('');
  const [selectTypeButton, setSelectedType] = React.useState("");
  const [showModal, setModal] = React.useState(false);
  const [testData, setTestData] = React.useState([]);
  const [adminData, setAdminData] = React.useState(0);
  const [tableDataHere, setTableData] = React.useState([]);
  const [isActiveTableLoading, setIsActiveTableLoading] = React.useState(false);
  const [tableGenerateDataHere, setGenerateTableData] = React.useState([]);
  const [isGenerateTableLoading, setIsGenerateTableLoading] = React.useState(false);
  const [examId, setExamId] = React.useState("");
  const [menuTitle, setMenuTitle] = React.useState(["Tests", "Completed", "Expired"]);
  const [_cssNav, setCssNav] = React.useState(["", "", "", "", "", "", "", ""]);
  const [selectedTab, setSelectedTab] = React.useState("");
  const [processData, setProcessData] = React.useState(true);
  const [codeLanguages, setCodeLanguages] = React.useState([]);
  const loading = useSelector(getLoading);
  const _groupDetails = useSelector(getGroupDetails);
  const typeButtonData = useSelector(getTypeButton);
  const userHomeData = useSelector(getUserHomeDetails);
  const orgId = useSelector(getOrgId);
  const buttonArray = useSelector(getButtonArray);
  const userRole = useSelector(selectRole);
  const userFullName = useSelector(selectFullName);
  //get testData function for handleChange

  useAutoLogout();

  React.useEffect(() => {
    axios
      .get("/test/getUserOrgData")
      .then((response) => {
        if (userRole !== "ROLE_SUPERADMIN") {
          // Use "Tests" as default if no selectedMenu is available
          const selectedMenu = response.data.result.length > 0 ? response.data.result[0].selectedMenu : (typeButtonData || "Tests");
          const organizationId = response.data.result.length > 0 ? response.data.result[0].orgId : orgId;
          leftPanelMenu(selectedMenu, organizationId);
        }
        if (response.data.result.length > 0) {
          dispatch(setTypeButton(response.data.result[0].typeButton));
          setSelectedTab(response.data.result[0].selectedMenu);
          dispatch(setOrgId(response.data.result[0].orgId));
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const leftPanelMenu = async (typeButton, organizationId) => {
    let data = {
      newValue: typeButton,
      org: organizationId ? organizationId : orgId,
    };
    await dispatch(addUserHome(data))
      .then((response) => {
        dispatch(setLoading());
        dispatch(setUserHomeDetails(response.payload));
        dispatch(setGroupDetails(response.payload.groups));
        let typeData = response.payload;
        handleHome(typeData, data.newValue);
      })
      .catch((e) => {
        console.log("addUserHome error:", e);
      });
  };

  const handleHome = (typeData, typeButton) => {

    let testType = [];
    testType.push("Tests");
    testType.push("Feedback");
    testType.push("Survey");
    testType.push("WorkFlow");
    testType.push("Disabled Groups");
    testType.push("Site Requirements");
    testType.push("Support");
    // testType.push("User Help");
    setType(testType);
    dispatch(setTypeButton(typeButton === "" ? (selectedTab !== "" ? selectedTab : testType[0]) : typeButton));
    // setTypeButton(typeButton === "" ? testType[0] : typeButton);

    // Always set org data first, regardless of TEST data
    dispatch(setOrgId(typeData.latestOrg));
    dispatch(setOrgData(typeData.org));

    let testData = typeData.groups?.TEST;
    if (!testData) {
      console.error("No TEST data found in groups!", typeData);
      dispatch(setButtonArray({}));
      return;
    }

    dispatch(setButtonArray(typeData.groups));
    let pendingArray = [],
      startedArray = [];

    // eslint-disable-next-line array-callback-return
    Object.keys(testData).map((item) => {
      pendingArray.push(testData[item][0]["000"]);
      startedArray.push(testData[item][0]["001"]);
    });
    setPending(pendingArray);
    setStarted(startedArray);
  };

  useEffect(() => {}, [showModal]);

  useEffect(() => {
    if (userHomeData) {
      handleHome(userHomeData, typeButtonData);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userHomeData, typeButtonData]);

  useEffect(() => {
    if (userRole === "ROLE_SUPERADMIN") {
      var testType = [];
      testType.push("Ongoing Tests");
      testType.push("Pending Results");
      testType.push("Regenerate Results");
      testType.push("Search Candidates");
      testType.push("Proctoring Insights");
      setType(testType);
      dispatch(setTypeButton(typeButtonData === "" ? testType[0] : typeButtonData));
      // eslint-disable-next-line no-lone-blocks
      {
        try {
          setIsActiveTableLoading(true);
          axios
            .get("/test/getActiveUsers")
            .then((response) => {
              // setTableData(Object.entries(response.data.result));
              if (response.data.result) {
                let tableDataValue = Object.entries(response.data.result);
                let arrActiveUSers = tableDataValue.filter((item) => item[1].activeTest);
                setTableData(arrActiveUSers);
                setAdminData(response.data.totalUsers);
                setIsActiveTableLoading(false);
              } else {
                setTableData([]);
              }
            });
        } catch (error) {
          console.log("ERROR: " + error);
        }
      }
      // eslint-disable-next-line no-lone-blocks
      {
        try {
          setIsGenerateTableLoading(true);
          axios
            .post("/test/regeneratelisting", {})
            .then((response) => {
              // setTableData(Object.entries(response.data.result));
              if (response.data) {
                setGenerateTableData(response.data.data);
                setIsGenerateTableLoading(false);
                // let tableDataValue = Object.entries(response.data.result);
                // let arrActiveUSers = tableDataValue.filter(item => item[1].activeTest);
                // setTableData(arrActiveUSers)
                // setAdminData(response.data.totalUsers)
              } else {
                setGenerateTableData([]);
              }
            });
        } catch (error) {
          console.log("ERROR: " + error);
        }
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userRole]);

  // useeffect to submit test if present in localstorage
  useEffect(() => {
    // Process immediately on dashboard load
    processPendingTestSubmissions();

    // Also flush on network recovery, not just on Dashboard mount - a
    // candidate whose submission got stranded because they were offline
    // shouldn't have to navigate back here for it to be retried.
    window.addEventListener("online", processPendingTestSubmissions);
    return () => window.removeEventListener("online", processPendingTestSubmissions);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Retrying an idempotent upsert costs almost nothing next to losing exam
  // data - previously capped at 5 attempts and then given up on silently
  // forever (console-only "Manual intervention needed"). Raised well past
  // any realistic number of Dashboard visits/online events so it effectively
  // never stops trying on its own.
  const MAX_PENDING_RETRIES = 100;

  const processPendingTestSubmissions = async () => {
    // Import IndexedDB utilities dynamically to avoid issues if not available
    let indexedDBStorage;
    try {
      indexedDBStorage = await import('../utils/indexedDBStorage');
    } catch (e) {
      console.log('IndexedDB storage not available, using localStorage fallback');
    }

    // Process test-submit keys from localStorage (failed final submissions,
    // legacy path / IndexedDB unavailable at the time they were saved)
    const submitKeys = getLocalStorageKeysByPrefix("test-submit");
    if (submitKeys.length > 0) {
      console.log(`📤 Processing ${submitKeys.length} pending test submissions (localStorage)...`);

      for (let i in submitKeys) {
        const key = submitKeys[i];
        try {
          const bodyData = JSON.parse(localStorage.getItem(key));

          const response = await axios.post(`/result/submittest/${bodyData.userExamId}`, bodyData, {
            headers: {
              "Access-Control-Allow-Origin": "*",
            },
          });

          if (response.status === 200) {
            localStorage.removeItem(key);
            console.log(`✅ Successfully submitted test: ${bodyData.userExamId}`);
          }
        } catch (error) {
          console.error(`❌ Failed to submit test (key: ${key}):`, error);
        }
      }
    }

    // Process test-submit keys from IndexedDB (primary storage as of this
    // fix - savePendingSubmission/getPendingSubmitKeys previously existed in
    // indexedDBStorage.js but nothing ever read them back)
    if (indexedDBStorage) {
      try {
        const pendingSubmitKeys = await indexedDBStorage.getPendingSubmitKeys();

        if (pendingSubmitKeys.length > 0) {
          console.log(`📤 Processing ${pendingSubmitKeys.length} pending test submissions (IndexedDB)...`);

          for (const key of pendingSubmitKeys) {
            try {
              const bodyData = await indexedDBStorage.getPendingData(key);
              if (!bodyData) continue;

              const response = await axios.post(`/result/submittest/${bodyData.userExamId}`, bodyData, {
                headers: {
                  "Access-Control-Allow-Origin": "*",
                },
              });

              if (response.status === 200) {
                await indexedDBStorage.removePendingData(key);
                console.log(`✅ Successfully submitted test from IndexedDB: ${bodyData.userExamId}`);
              }
            } catch (error) {
              console.error(`❌ Failed to submit test from IndexedDB (key: ${key}):`, error);
            }
          }
        }
      } catch (dbError) {
        console.error('IndexedDB submit-key processing error:', dbError);
      }
    }

    // Process pending test data from IndexedDB (primary storage)
    if (indexedDBStorage) {
      try {
        const pendingDataKeys = await indexedDBStorage.getPendingDataKeys();

        if (pendingDataKeys.length > 0) {
          console.log(`📤 Processing ${pendingDataKeys.length} pending test data saves (IndexedDB)...`);

          for (const key of pendingDataKeys) {
            try {
              const retryData = await indexedDBStorage.getPendingData(key);
              if (!retryData) continue;

              if (retryData.retryCount >= MAX_PENDING_RETRIES) {
                console.error(`❌ Max retries exceeded for ${key}. Manual intervention needed.`);
                continue;
              }

              // Attempt to save to MongoDB
              const response = await axios.post("/test/answeredQuestions", {
                headers: {
                  "Access-Control-Allow-Origin": "*",
                },
                examDetail: retryData.examDetail,
                id: retryData.userExamId,
                quesData: retryData.quesData,
              });

              if (response.status === 200) {
                await indexedDBStorage.removePendingData(key);
                console.log(`✅ Successfully synced from IndexedDB: ${retryData.userExamId}`);
              }
            } catch (error) {
              console.error(`❌ Retry failed for ${key}:`, error);
              await indexedDBStorage.incrementRetryCount(key);
            }
          }
        }
      } catch (dbError) {
        console.error('IndexedDB processing error:', dbError);
      }
    }

    // Also check localStorage for test-data-pending (backward compatibility / fallback)
    const pendingDataKeys = getLocalStorageKeysByPrefix("test-data-pending");
    if (pendingDataKeys.length > 0) {
      console.log(`📤 Processing ${pendingDataKeys.length} pending test data saves (localStorage fallback)...`);

      for (let i in pendingDataKeys) {
        const key = pendingDataKeys[i];
        try {
          const retryData = JSON.parse(localStorage.getItem(key));

          if (retryData.retryCount >= MAX_PENDING_RETRIES) {
            console.error(`❌ Max retries exceeded for ${key}.`);
            continue;
          }

          const response = await axios.post("/test/answeredQuestions", {
            headers: {
              "Access-Control-Allow-Origin": "*",
            },
            examDetail: retryData.examDetail,
            id: retryData.userExamId,
            quesData: retryData.quesData,
          });

          if (response.status === 200) {
            localStorage.removeItem(key);
            console.log(`✅ Successfully saved pending data: ${retryData.userExamId}`);
          }
        } catch (error) {
          console.error(`❌ Retry failed for ${key}:`, error);

          try {
            const retryData = JSON.parse(localStorage.getItem(key));
            retryData.retryCount += 1;
            retryData.timestamp = new Date().toISOString();
            localStorage.setItem(key, JSON.stringify(retryData));
          } catch (updateError) {
            console.error("Failed to update retry data:", updateError);
          }
        }
      }
    }
  };

  function getLocalStorageKeysByPrefix(prefix) {
    const matchingKeys = [];

    // Iterate over all keys in localStorage
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);

      // Check if the key starts with the desired prefix
      if (key.startsWith(prefix)) {
        matchingKeys.push(key);
      }
    }

    console.log(matchingKeys);

    return matchingKeys;
  }

  const [open, setOpen] = React.useState(true);
  const [dimensions, setDimensions] = React.useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleResize = () => {
    setDimensions({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };

  React.useEffect(() => {
    window.addEventListener("resize", handleResize, false);
    return () => {
      window.removeEventListener("resize", handleResize, false);
    };
  }, []);

  const closeModal = () => {
    setModal(false);
    window.location.reload(false);
  };
  const handleDownlaodReport = (data) => {
    setProcessData(false);
    try {
      // axios instance carries the HttpOnly auth_token cookie via withCredentials.
      axios
        .get(`/report/download/${data.groupId}`, {
          responseType: "arraybuffer",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/pdf",
          },
        })
        .then((response) => {
          // Create a Blob from the PDF Stream
          setProcessData(true);
          const pdfBlob = new Blob([response.data], { type: "application/pdf" });
          const blobUrl = window.URL.createObjectURL(pdfBlob);
          const link = document.createElement("a");
          link.href = blobUrl;
          const addName = (userFullName || "report") + "-" + Date.now() + ".pdf";
          link.setAttribute("download", addName);
          link.click();
          link.remove();
          URL.revokeObjectURL(blobUrl);
        })
        .catch((error) => {
          console.log("AXIOS ERROR: " + error);
          setProcessData(true); // Reset loading state on error
        });
    } catch (error) {
      console.log("ERROR: " + error);
      setProcessData(true); // Reset loading state on error
    }
  };

  //   useUnload(e => {
  //     debugger;
  //     //e.preventDefault();
  //.consle.log('Window close event====>');
  //     //alert("Window closed");
  //     let browseRefresh = Cookies.get('login');
  //.consle.log('browseRefresh value====>', browseRefresh);
  //     if(browseRefresh === null){

  //     axios.get("/v3/login/logout", {
  //       headers: {
  //         'Access-Control-Allow-Origin': '*',
  //       }
  //     }).then(userData => {

  //       if(userData.data.status === 'Logout'){
  //.consle.log('value ====>successful logout');

  //         Cookies.set('token', '', { path: '/' });//expires: 7,
  //        props.setUser(false);
  // //        props.history.push('/v2/user/');
  //         // window.location.href='http://192.168.31.35:3000/v2/user';
  //         // window.location.reload();
  //       }
  //     }).catch(error => {
  //.consle.log('userData error====>', error);//, error.response.data
  //     });
  //   }
  //   });

  //     return(
  //         <div className={classes.root}>
  //           <div id='switchw'></div>
  //           {!showModal ?
  //           <>
  //             <CssBaseline />
  //             <AppBar open={open} handleDrawerOpen={handleDrawerOpen} handleDrawerClose={handleDrawerClose}
  //             themeType={props.themeType} changeTheme={props.changeTheme} history={props.history} />
  //             <Drawer open={open} handleDrawerOpen={handleDrawerOpen} handleDrawerClose={handleDrawerClose}
  //             testType={typeValue} setTypeButton={setTypeButton} setSelectedType={setSelectedType} />
  //             {(typeButton === 'Tests' || typeButton === 'Survey') ?
  //               <DashboardGrid pending={pending} started={started} buttonArray={buttonArray}
  //               buttonName={buttonName} setButtonClicked={setButtonClicked} typeButton={typeButton}
  //               selectTypeButton={selectTypeButton} setSelectedType={setSelectedType}
  //               setModal={setModal} setTestData={setTestData} setExamId={setExamId} />
  //             :
  //               (typeButton === 'Feedback')
  //               ?
  //                 <FeedbackDashboardGrid pending={pending} started={started} buttonArray={buttonArray}
  //                 buttonName={buttonName} setButtonClicked={setButtonClicked} typeButton={typeButton}
  //                 selectTypeButton={selectTypeButton} setSelectedType={setSelectedType} />

  //               :
  //               (typeButton === 'Completed')
  //               ?
  //                 <CompletedDashboardGrid pending={pending} started={started} buttonArray={buttonArray}
  //                 buttonName={buttonName} setButtonClicked={setButtonClicked} typeButton={typeButton}
  //                 selectTypeButton={selectTypeButton} setSelectedType={setSelectedType} />
  //               :
  //               (typeButton === 'Expired')
  //               ?
  //                 <ExpiredDashboardGrid pending={pending} started={started} buttonArray={buttonArray}
  //                 buttonName={buttonName} setButtonClicked={setButtonClicked} typeButton={typeButton}
  //                 selectTypeButton={selectTypeButton} setSelectedType={setSelectedType} />
  //               :
  //               (typeButton === 'Support' || typeButton === 'User Help')
  //               ?
  //                 <Support typeButton={typeButton} />
  //               :
  //               (typeButton === 'Site Requirements')
  //               ?
  //                 <SiteRequirement typeButton={typeButton} />
  //               :
  //               (typeButton === 'Practice')
  //               ?
  //                 <Practice pending={pending} started={started} buttonArray={buttonArray}
  //                 buttonName={buttonName} setButtonClicked={setButtonClicked} typeButton={typeButton}
  //                 selectTypeButton={selectTypeButton} setSelectedType={setSelectedType}
  //                 setModal={setModal} setTestData={setTestData} setExamId={setExamId} />
  //               :
  //                 <></>
  //             }
  //           </>
  //           :
  //           <Dialog fullScreen open={showModal} onClose={closeModal} TransitionComponent={Transition}>

  //           {/* <ReactModal
  //           isOpen={showModal}
  //           contentLabel="User Exam"
  //           ariaHideApp={false}

  //           className={classes.overlay}
  //           style={{
  //             backgroundColor: (props.themeType === 'light') ? 'red' : '#FFF'

  //           }}
  //         > */}
  //           <Test themeType={props.themeType} changeTheme={props.changeTheme}
  //           closeModal={closeModal} testData={testData} examId={examId} />
  //         {/* </ReactModal> */}
  //         </Dialog>
  //         }

  //         </div>
  //     );
  // }
  const handleIconCLick = (index, text) => {
    dispatch(setTypeButton(text));
    setSelectedTab(text);
    setCssNav(["", "", "", "", "", "", "", ""]);
    let a = ["", "", "", "", "", "", "", ""];
    a[index] = classes.active;
    setCssNav(a);
    let data = {
      typeButton: "",
      newValue: "",
    };
    if (text === "Tests") {
      data = {
        typeButton: text,
        newValue: "Tests",
        org: orgId,
      };
      dispatch(setTypeButton(data.typeButton));
      setSelectedTab(data.newValue);
    } else if (text === "Feedback") {
      data = {
        typeButton: text,
        newValue: "Feedback",
        org: orgId,
      };
      dispatch(setTypeButton(data.typeButton));
      setSelectedTab(data.newValue);
    } else if (text === "Disabled Groups") {
      data = {
        typeButton: text,
        newValue: "Disabled Groups",
        org: orgId,
      };
      dispatch(setTypeButton(data.typeButton));
      setSelectedTab(data.newValue);
    } else if (text === "Site Requirements" || text === "Support") {
      data = {
        typeButton: text,
        newValue: "",
        org: orgId,
      };
      dispatch(setTypeButton(data.typeButton));
      setSelectedTab(data.newValue);
    } else if (text === "WorkFlow") {
      data = {
        typeButton: text,
        newValue: "WorkFlow",
        org: orgId,
      };
      dispatch(setTypeButton(data.typeButton));
      setSelectedTab(data.newValue);
    } else {
      data = {
        typeButton: text,
        newValue: "Survey",
        org: orgId,
      };
      dispatch(setTypeButton(data.typeButton));
      setSelectedTab(data.newValue);
    }
    dispatch(setTypeButton(text));
    if (userRole !== "ROLE_SUPERADMIN") {
      leftPanelMenu(text);
    }
    if (text === "User Help") {
      return (
        <Link href="../../docs/ConductOnlineTest.html" target="_blank">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a>thesitewizard.com</a>
        </Link>
      );

      //    return (<a href={require('./docs/ConductOnlineTest.html')} target="_blank">thesitewizard.com</a>)
    }
    setSelectedType(
      text === "Tests"
        ? "TEST"
        : text === "Practice"
        ? "PRACTISE"
        : text === "Survey"
        ? "SURVEY"
        : text === "Feedback"
        ? "FEEDBACK"
        : text === "Completed"
        ? "COMPLETED"
        : text === "Expired"
        ? "EXPIRED"
        : text === "WorkFlow"
        ? "WORKFLOW"
        : text === "Disabled Groups"
        ? "DISABLED"
        : ""
    );
  };

  return (
    <div id="main-body-two" className={classes.root}>
      <div id="switchw"></div>
      {!showModal ? (
        <>
          <CssBaseline />
          <AppBar
            open={open}
            handleDrawerOpen={handleDrawerOpen}
            handleDrawerClose={handleDrawerClose}
            themeType={props.themeType}
            changeTheme={props.changeTheme}
            history={props.history}
          />
          <Drawer
            dimensions={dimensions}
            typeButton={typeButtonData}
            handleIconCLick={handleIconCLick}
            open={open}
            leftPanelMenu={leftPanelMenu}
            handleDrawerOpen={handleDrawerOpen}
            handleDrawerClose={handleDrawerClose}
            testType={typeValue}
            setTypeButton={setTypeButton}
            dispatch={dispatch}
            setSelectedType={setSelectedType}
          />
          {typeButtonData === "Tests" || typeButtonData === "Survey" || typeButtonData === "WorkFlow" ? (
            <DashboardGrid
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
              setMenuTitle={setMenuTitle}
              menuTitle={menuTitle}
              handleIconCLick={handleIconCLick}
              setLoading={setLoading}
              dispatch={dispatch}
              loading={loading}
              handleHome={handleHome}
              pending={pending}
              started={started}
              buttonArray={buttonArray}
              buttonName={buttonName}
              setButtonClicked={setButtonClicked}
              typeButton={typeButtonData}
              selectTypeButton={selectTypeButton}
              setSelectedType={setSelectedType}
              setModal={setModal}
              setTestData={setTestData}
              setExamId={setExamId}
              examId={examId}
              setCodeLanguages={setCodeLanguages}
            />
          ) : typeButtonData === "Feedback" ? (
            <FeedbackDashboardGrid
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
              setMenuTitle={setMenuTitle}
              menuTitle={menuTitle}
              showModal={showModal}
              setLoading={setLoading}
              setExamId={setExamId}
              handleHome={handleHome}
              pending={pending}
              started={started}
              buttonArray={buttonArray}
              buttonName={buttonName}
              setButtonClicked={setButtonClicked}
              typeButton={typeButtonData}
              setModal={setModal}
              selectTypeButton={selectTypeButton}
              setTestData={setTestData}
              dispatch={dispatch}
              setSelectedType={setSelectedType}
              examId={examId}
              loading={loading}
              setCodeLanguages={setCodeLanguages}
            />
          ) : typeButtonData === "Completed" ||
            typeButtonData === "FeedbackCompleted" ||
            typeButtonData === "SurveyCompleted" ||
            typeButtonData === "WorkFlowCompleted" ? (
            <CompletedDashboardGrid
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
              setMenuTitle={setMenuTitle}
              menuTitle={menuTitle}
              handleIconCLick={handleIconCLick}
              setLoading={setLoading}
              dispatch={dispatch}
              loading={loading}
              handleHome={handleHome}
              pending={pending}
              handleDownlaodReport={handleDownlaodReport}
              process={processData}
              started={started}
              buttonArray={buttonArray}
              buttonName={buttonName}
              setButtonClicked={setButtonClicked}
              typeButton={typeButtonData}
              selectTypeButton={selectTypeButton}
              setSelectedType={setSelectedType}
            />
          ) : typeButtonData === "Expired" ||
            typeButtonData === "FeedbackExpired" ||
            typeButtonData === "SurveyExpired" ||
            typeButtonData === "WorkFlowExpired" ? (
            <ExpiredDashboardGrid
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
              setMenuTitle={setMenuTitle}
              menuTitle={menuTitle}
              handleIconCLick={handleIconCLick}
              setLoading={setLoading}
              dispatch={dispatch}
              loading={loading}
              handleHome={handleHome}
              pending={pending}
              started={started}
              buttonArray={buttonArray}
              buttonName={buttonName}
              setButtonClicked={setButtonClicked}
              typeButton={typeButtonData}
              selectTypeButton={selectTypeButton}
              setSelectedType={setSelectedType}
            />
          ) : typeButtonData === "Disabled Groups" ||
            typeButtonData === "Disabled Feedback" ||
            typeButtonData === "Disabled Survey" ? (
            <DisabledDashboardGrid
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
              setMenuTitle={setMenuTitle}
              menuTitle={menuTitle}
              handleIconCLick={handleIconCLick}
              setLoading={setLoading}
              dispatch={dispatch}
              loading={loading}
              handleHome={handleHome}
              pending={pending}
              started={started}
              buttonArray={buttonArray}
              buttonName={buttonName}
              setButtonClicked={setButtonClicked}
              typeButton={typeButtonData}
              selectTypeButton={selectTypeButton}
              setSelectedType={setSelectedType}
            />
          ) : typeButtonData === "Support" || typeButtonData === "User Help" ? (
            <Support typeButton={typeButtonData} />
          ) : typeButtonData === "Site Requirements" ? (
            <SiteRequirement handleHome={handleHome} typeButton={typeButtonData} />
          ) : typeButtonData === "Practice" ? (
            <Practice
              pending={pending}
              started={started}
              buttonArray={buttonArray}
              buttonName={buttonName}
              setButtonClicked={setButtonClicked}
              typeButton={typeButtonData}
              selectTypeButton={selectTypeButton}
              dispatch={dispatch}
              setSelectedType={setSelectedType}
              setModal={setModal}
              setTestData={setTestData}
              setExamId={setExamId}
            />
          ) : typeButtonData === "Ongoing Tests" ? (
            <AdminDashboardGrid adminData={adminData} tableData={tableDataHere} isActiveTableLoading={isActiveTableLoading} />
          ) : typeButtonData === "Pending Results" ? (
            <GenerateList tableData={tableGenerateDataHere} isGenerateTableLoading={isGenerateTableLoading} />
          ) : typeButtonData === "Regenerate Results" ? (
            <SearchUserDetails
              buttonName={buttonName}
              setButtonClicked={setButtonClicked}
              // handleDownlaodReport={handleDownlaodReport} process={processData}
            />
          ) : typeButtonData === "Search Candidates" ? (
            <CandidateSearch />
          ) : typeButtonData === "Proctoring Insights" ? (
            <ProctoringFacts />
          ) : (
            <></>
          )}
        </>
      ) : (
        <Dialog PaperProps={{ style: { background: "#e5e5e9" } }} fullScreen open={showModal} onClose={closeModal} slots={{ transition: Transition }}>
          <Test
            themeType={props.themeType}
            changeTheme={props.changeTheme}
            closeModal={closeModal}
            testData={testData}
            examId={examId}
            setTestData={setTestData}
            codeLanguages={codeLanguages}
          />
        </Dialog>
      )}
      <SupportBot authenticated={true} user={{ firstname: userFullName }} />
    </div>
  );
};

export default Dashboard;
